/* 4U BUNDLE SIZE SYNC (Core 4" Mesh Shorts + Tank bundle, Essentials Tank
   3-pack).
   - Every time the shopper changes the size of the FIRST item in a bundle,
     the other items switch to the same size (if it's in stock).
   - If the shopper manually changes the size of any OTHER item, that item
     is "locked": from then on it keeps their choice and is never
     auto-changed again (so different sizes are always possible).
   - Colour changes never trigger it.
   Loaded (cached) from snippets/media.liquid on product pages. */
(function(){
  if (window.__fuSizeSync) return;
  window.__fuSizeSync = true;

  var SIZE_RE = /^(xxs|xs|s|m|l|xl|xxl|2xl|3xl|4xl|small|medium|large|x-large|os|one size)$/i;
  var BUNDLES = [
    { root: '#pb2bd', slot: '.pb02-slot' },
    { root: '#pb3pk', slot: '.pb01-slot' }
  ];
  var busy = false;

  function cleanText(t){ return String(t || '').replace(/\s*[-\u2013(].*$/, '').trim(); }
  function isSizeSelect(sel){
    var opts = Array.prototype.slice.call(sel.options).filter(function(o){ return o.value !== ''; });
    if (!opts.length) return false;
    var hits = opts.filter(function(o){ return SIZE_RE.test(cleanText(o.textContent)) || SIZE_RE.test(String(o.value)); }).length;
    return hits / opts.length >= 0.6;
  }
  function sizeSelectIn(slot){
    var sels = slot.querySelectorAll('select');
    for (var i = 0; i < sels.length; i++) if (isSizeSelect(sels[i])) return sels[i];
    return null;
  }
  function optSize(o){
    var t = cleanText(o.textContent);
    return SIZE_RE.test(t) ? t.toLowerCase() : String(o.value).toLowerCase();
  }
  function inStock(o){
    return !o.disabled && !/sold\s*out|unavailable/i.test(o.textContent);
  }

  document.addEventListener('change', function(e){
    if (busy) return;
    var sel = e.target;
    if (!sel || sel.tagName !== 'SELECT') return;
    for (var b = 0; b < BUNDLES.length; b++) {
      var cfg = BUNDLES[b];
      var root = sel.closest(cfg.root);
      if (!root) continue;
      if (!isSizeSelect(sel)) return;
      var slots = Array.prototype.slice.call(root.querySelectorAll(cfg.slot));
      if (!slots.length) return;
      var mySlot = sel.closest(cfg.slot);

      /* Shopper changed a later item's size: lock that item. */
      if (mySlot !== slots[0]) { if (mySlot) mySlot.__fuSizeLocked = true; return; }

      /* First item's size changed: match every unlocked item. */
      var picked = sel.options[sel.selectedIndex];
      if (!picked || picked.value === '') return;
      var want = optSize(picked);
      busy = true;
      slots.slice(1).forEach(function(slot){
        if (slot.__fuSizeLocked) return;
        var other = sizeSelectIn(slot);
        if (!other) return;
        for (var i = 0; i < other.options.length; i++) {
          var o = other.options[i];
          if (o.value !== '' && optSize(o) === want && inStock(o)) {
            if (other.selectedIndex !== i) {
              other.selectedIndex = i;
              other.dispatchEvent(new Event('change', { bubbles: true }));
              other.dispatchEvent(new Event('input', { bubbles: true }));
            }
            break;
          }
        }
      });
      busy = false;
      return;
    }
  }, true);
})();
